import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { UtmLeadService } from "../services/utmleads/utmLeads.service";
import { persistUtmReferral, resolveUtmReferral } from "../services/utmleads/utmReferral";

const SENT_KEY = "utm_clickids_enviados";

const readSent = () => {
  try {
    return JSON.parse(sessionStorage.getItem(SENT_KEY) || "[]");
  } catch (e) {
    return [];
  }
};

const markSent = (clickId) => {
  try {
    sessionStorage.setItem(SENT_KEY, JSON.stringify([...readSent(), clickId]));
  } catch (e) {
    // sessionStorage no disponible
  }
};

export function useUtmTracking({ createLead = false } = {}) {
  const [searchParams] = useSearchParams();
  const searchParamsKey = searchParams.toString();

  useEffect(() => {
    const referral = persistUtmReferral(
      resolveUtmReferral(new URLSearchParams(searchParamsKey)),
    );

    if (!createLead || !referral?.clickId || !referral?.partnerId) return;
    if (readSent().includes(referral.clickId)) return;

    void UtmLeadService.createUtmLead({
      payload: {
        partnerId: referral.partnerId,
        clickId: referral.clickId,
        typeCustomer: referral.typeCustomer,
      },
    }).then((response) => {
      if (response.error) {
        if (/duplic|already|exist|E11000/i.test(`${JSON.stringify(response.message)}`)) {
          markSent(referral.clickId);
        }
        console.warn(`[UtmLead] No fue posible crear el lead: ${response.message}`);
        return;
      }

      markSent(referral.clickId);
      const operationIdUtm = response.message?.data?.operationIdUtm;
      if (operationIdUtm) localStorage.setItem("operationIdUtm", operationIdUtm);
    });
  }, [createLead, searchParamsKey]);
}
